import { useCallback, useEffect, useRef } from 'react'
import { useRouter } from 'next/router'

/**
 * @returns {JSX.Element}
 * @author: Josep Vidal
 * Move to Hook by Josep D
 * @constructor
 */
const useOVRNavigator = ({
  rightSideContentVisible,
  onRightSideLeftArrowClick,
  nextJSLinkInRightSideLeftArrow,
  onRightSideRightArrowClick,
  nextJSLinkInRightSideRightArrow,
  rightSideDisabled,
  navigationKey
}) => {
  const router = useRouter()
  // Experimental: Arrow is always visible, but disabled when unnecessary
  const rightSideLeftArrowVisible = !!(nextJSLinkInRightSideLeftArrow || onRightSideLeftArrowClick) || rightSideDisabled
  // const rightSideLeftArrowVisible = true
  const rightSideCenterContentVisible =
    !!(
      nextJSLinkInRightSideLeftArrow ||
      onRightSideLeftArrowClick ||
      nextJSLinkInRightSideRightArrow ||
      onRightSideRightArrowClick
    ) || rightSideDisabled
  // Experimental: Arrow is always visible, but disabled when unnecessary
  const rightSideRightArrowVisible =
    !!(nextJSLinkInRightSideRightArrow || onRightSideRightArrowClick) || rightSideDisabled
  // const rightSideRightArrowVisible = true
  const backLinkStored = navigationKey

  const leftArrowRef = useRef()
  const rightArrowRef = useRef()

  const handleUserKeyPress = useCallback(event => {
    const { keyCode } = event
    if (!document.body.className.match('dimmable dimmed') && rightSideContentVisible) {
      const isArtWorkNavigation = (nextJSLinkInRightSideRightArrow?.href?.pathname === '/artwork' || nextJSLinkInRightSideRightArrow?.href?.pathname === '/artwork')
      const currentPathname = isArtWorkNavigation ? '/artwork' : '/room'
      const queryObj = isArtWorkNavigation ? { comingFromOVRRoom: true } : {}

      if (rightSideLeftArrowVisible && keyCode === 37) {
        // @ts-ignore
        leftArrowRef.current.click(router.push(
          {
            pathname: currentPathname,
            query: queryObj
          }, nextJSLinkInRightSideLeftArrow?.as))
      }

      if (rightSideRightArrowVisible && keyCode === 39) {
        // @ts-ignore
        rightArrowRef.current.click(router.push(
          {
            pathname: currentPathname,
            query: queryObj
          }, nextJSLinkInRightSideRightArrow?.as))
      }
    }
  }, [rightSideRightArrowVisible, rightSideLeftArrowVisible, router, nextJSLinkInRightSideLeftArrow,
    nextJSLinkInRightSideRightArrow, rightSideContentVisible])

  useEffect(() => {
    window.addEventListener('keyup', handleUserKeyPress)
    return () => {
      window.removeEventListener('keyup', handleUserKeyPress)
    }
  }, [handleUserKeyPress])

  return {
    rightSideCenterContentVisible,
    rightSideLeftArrowVisible,
    rightSideRightArrowVisible,
    backLinkStored,
    leftArrowRef,
    rightArrowRef
  }

}
export default useOVRNavigator
